/* unplugin-vue-components disabled */import script from "./orderGatherExport.vue?vue&type=script&setup=true&lang=js"
export * from "./orderGatherExport.vue?vue&type=script&setup=true&lang=js"

import "./orderGatherExport.vue?vue&type=style&index=0&id=0d243204&lang=scss"

const __exports__ = script;

export default __exports__